import React, { useEffect } from 'react';
import { useAuth } from 'helpers/authContext';

interface AdSenseProps {
    slot?: string;
    format?: 'auto' | 'fluid' | 'rectangle';
    layout?: 'display' | 'in-article' | 'feed';
    type?: 'card' | 'horizontal';
    className?: string;
}

export const AdSense: React.FC<AdSenseProps> = ({ 
    slot = "3459013520903929", // Default slot if needed, though usually each unit has its own
    format = 'auto',
    layout,
    type = 'horizontal',
    className = ""
}) => {
    const { site_settings } = useAuth();
    const adsEnabled = site_settings?.ads_enabled === 'true';

    useEffect(() => {
        if (adsEnabled) {
            try {
                ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
            } catch (e) {
                console.error("AdSense error:", e);
            }
        }
    }, [adsEnabled]);

    if (!adsEnabled) return null;

    if (type === 'card') {
        return (
            <div className={`col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 pb-3 ${className}`}>
                <div className="card-stats card item-speem pd-0 m-0 h-100 d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                    <div className="text-muted small mb-2">Advertisement</div>
                    <ins className="adsbygoogle"
                        style={{ display: 'block', width: '100%', height: '100%' }}
                        data-ad-client="ca-pub-3459013520903929"
                        data-ad-slot={slot}
                        data-ad-format={format}
                        data-ad-layout={layout}
                        data-full-width-responsive="true"
                    ></ins>
                </div>
            </div>
        );
    }

    return (
        <div className={`adsense-wrapper my-3 ${className}`} style={{ width: '100%', overflow: 'hidden' }}>
            <div className="text-muted x-small text-center mb-1">Advertisement</div>
            <ins className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-3459013520903929"
                data-ad-slot={slot}
                data-ad-format={format}
                data-ad-layout={layout}
                data-full-width-responsive="true"
            ></ins>
        </div>
    );
};

export default AdSense;
